module.exports = __webpack_public_path__ + "img/107d299.svg";